<template>
  <div>
    <b-modal
      no-close-on-backdrop
      centered
      hide-footer
      id="modalProd"
      size="xl"
      v-model="open"
      :title="` Detalhes do pedido ${uuid}`"
      :busy="loading"
    >
      <div id="printable">
        <b-row class="mb-2" v-if="!loading">
          <b-col cols="12" class="mt-2 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18">Status do pedido</span>
          </b-col>

          <b-col
            cols="12"
            v-if="
              dataModal.status != ORDER_STATUS.DELIVERED &&
              dataModal.status != ORDER_STATUS.CANCELED &&
              dataModal.status != ORDER_STATUS.EXPIRED &&
              dataModal.status != ORDER_STATUS.WAITING_PAYMENT
            "
          >
            <b-row>
              <b-col cols="10">
                <SelectItems
                  label="name"
                  v-model="statusModal"
                  :items="
                    dataModal.delivery == 'delivery'
                      ? orderStatusItems
                      : orderStatusItemStore
                  "
                  :placeholder="getOrderStatusText(dataModal.status)"
                  :reduceFunction="(orderStatus) => orderStatus.id"
                  :loading="loading"
                />
              </b-col>
              <b-col>
                <button
                  class="btn btn-success btn-block mr-4"
                  id="updateStatusButton"
                  @click="
                    statusModal == ORDER_STATUS.DELIVERED
                      ? confirmUpdateStatusWhenFinishedorCancel(
                          dataModal.id,
                          dataModal.paymentType
                        )
                      : ChangeStatus(statusModal, (popover = true))
                  "
                >
                  Salvar
                </button>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-else cols="12">
            <div>
              <div
                class="badge badge-success fs-18"
                v-if="dataModal.status === ORDER_STATUS.DELIVERED"
              >
                Entregue
              </div>
              <div
                class="badge badge-danger fs-18"
                v-else-if="dataModal.status === ORDER_STATUS.CANCELED"
              >
                Cancelado
              </div>
              <div
                class="badge badge-danger fs-18"
                v-else-if="dataModal.status === ORDER_STATUS.EXPIRED"
              >
                Expirado
              </div>
              <div
                class="badge badge-warning fs-18"
                v-else-if="dataModal.status === ORDER_STATUS.WAITING_PAYMENT"
              >
                Aguardando pagamento
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="loading">
          <b-col cols="12" class="text-center">
            <b-spinner label="Spinning"></b-spinner>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col cols="12" class="mt-2 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18">Detalhes do pedido</span>
          </b-col>
          <b-col cols="3">
            <Info
              label="Número do pedido"
              :value="uuid"
              :icon="'fas fa-list-ol'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="Valor total pedido"
              :value="formatNumber(fields.totalValue)"
              :icon="'fas fa-file-invoice-dollar'"
            />
          </b-col>
          <b-col cols="5">
            <Info
              label="Valor do frete"
              :value="formatNumber(fields.shipping)"
              :icon="'fas fa-truck'"
            />
          </b-col>
          <b-col cols="3" class="mt-2 mb-2">
            <Info
              label="Tipo de pagamento"
              :value="getPaymentTypeText(fields.paymentType)"
              :icon="'fas fa-cash-register'"
            />
          </b-col>
          <b-col cols="6" class="mt-2 mb-2">
            <Info
              label="Data do pagamento"
              :value="fields.paidAt"
              :icon="'fas fa-calendar-alt'"
            />
          </b-col>
          <b-col cols="12 mt-2" v-if="fields.paymentDelivery != ''">
            <Info
              label="Tipo de entrega"
              :value="tipoEntrega(fields.paymentDelivery)"
              :icon="'fas fa-exclamation'"
            />
            <strong>Endereço: </strong>{{ fields.paymentAddress }}
          </b-col>
          <b-col
            cols="6 mt-2"
            v-if="
              fields.paymentDelivery == 'delivery' &&
              fields.paymentAddress != ''
            "
          >
            <Info
              label="Endereço de entrega"
              :value="fields.paymentAddress"
              :icon="'fas fa-map-marker-alt'"
            />
          </b-col>
          <b-col
            cols="12 mt-2"
            v-if="fields.paymentExtra != '' && fields.paymentExtra != null"
          >
            <Info
              :label="
                fields.paymentType == 'credit_card'
                  ? 'Quantidade de parcela(s)'
                  : 'Extras'
              "
              :value="fields.paymentExtra"
            />
          </b-col>
          <b-col cols="12" class="mt-2 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18">Produtos</span>
          </b-col>
          <b-col cols="12" class="mt-2">
            <b-table-simple hover small responsive>
              <b-thead>
                <b-tr variant="primary" class="border-0">
                  <b-th class="text-center"></b-th>
                  <b-th>Nome</b-th>
                  <b-th class="text-center">Cód. Int.</b-th>
                  <b-th class="text-center">Preço</b-th>
                  <b-th class="text-center">Quantidade</b-th>
                  <b-th class="text-center">Total produto</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  @click="
                    $refs.orderDetailsModal.toggleOpen({ product: product })
                  "
                  v-for="(product, index) in fields.products"
                  :key="index"
                >
                  <b-td class="text-center">
                    <div>
                      <b-img
                        :src="linkImage(product.image)"
                        width="60"
                        height="50"
                        :alt="product.image"
                      ></b-img>
                    </div>
                  </b-td>
                  <b-td>{{ product.name }}</b-td>
                  <b-td class="text-center">{{
                    product.codInt ? product.codInt : '-'
                  }}</b-td>
                  <b-td class="text-center">{{
                    formatNumber(product.price)
                  }}</b-td>
                  <b-td class="text-center">{{ product.quantity }}</b-td>
                  <b-td class="text-center">{{
                    formatNumber(product.totalPrice)
                  }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>

          <b-col
            v-if="fields.services && fields.services[0].length > 0"
            cols="12"
            class="mt-2 mb-2 text-center cardTitleConst"
          >
            <span class="font-weight-bold fs-18">Serviços</span>
          </b-col>
          <b-col
            v-if="fields.services && fields.services[0].length > 0"
            cols="12"
            class="mt-2"
          >
            <b-table-simple hover small responsive>
              <b-thead>
                <b-tr variant="primary" class="border-0">
                  <b-th>Detalhes</b-th>
                  <b-th>Descrição</b-th>
                  <b-th class="d-flex justify-content-end mr-4">Valor</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="service in fields.services[0]" :key="service">
                  <b-td class="mr-4">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      title="Detalhes do pedido"
                      class="mr-2 mb-2"
                      @click="
                        $refs.detailServicePurchaseModal.toggleOpen({
                          item: service,
                        })
                      "
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>
                  </b-td>
                  <b-td class="ml-5">{{ service.service_name }}</b-td>
                  <b-td class="d-flex justify-content-end mr-4"
                    >R$ {{ service.service_price }}</b-td
                  >
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>

          <b-col
            v-if="fields.coupon"
            cols="12"
            class="mt-2 mb-2 text-center cardTitleConst"
          >
            <span class="font-weight-bold fs-18">Cupom de desconto</span>
          </b-col>
          <b-col v-if="fields.coupon" cols="12" class="mt-2">
            <b-table-simple hover small responsive>
              <b-thead>
                <b-tr variant="primary" class="border-0">
                  <b-th>Cupom</b-th>
                  <b-th class="d-flex justify-content-end mr-4"
                    >Valor do cupom de desconto</b-th
                  >
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td class="ml-5">{{ fields.coupon.coupon }}</b-td>
                  <b-td
                    style="color: red; margin-right: 150px"
                    class="d-flex justify-content-end"
                  >
                    - {{ fields.coupon.discount }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
          <b-col cols="12" class="mt-2 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18"
              >Resumo de taxas e recebimento</span
            >
          </b-col>
          <b-col cols="12" class="mt-2">
            <b-table-simple hover small responsive>
              <b-thead>
                <b-tr variant="primary" class="border-0">
                  <b-th>Valor total pedido</b-th>
                  <b-th>Frete</b-th>
                  <b-th>Transportadora</b-th>
                  <b-th>Taxa transação</b-th>
                  <b-th>Taxa Parcelamento</b-th>
                  <b-th>Valor a receber</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>{{ formatNumber(fields.totalValue) }}</b-td>
                  <b-td>
                    <span v-if="fields.shipping">{{
                      formatNumber(fields.shipping)
                    }}</span>
                    <div
                      v-if="(fields.shippingInfo || {}).picture"
                      :title="`A entrega será realizada por: ${
                        (fields.shippingInfo || {}).name
                      }`"
                    >
                      <b-img
                        :src="fields.shippingInfo.picture"
                        width="100px"
                        fluid
                      ></b-img>
                    </div>
                    <span
                      v-if="fields.shipping == '' || fields.shipping == null"
                    >
                      R$ 0,00
                    </span>
                  </b-td>
                  <p
                    v-if="
                      tipoEntrega(fields.paymentDelivery) == 'Retirada em loja'
                    "
                  >
                    Retirada na loja
                  </p>
                  <p v-else>{{ fields.queryShippingName }}</p>
                  <b-td> {{ formatNumber(taxPayment) }}</b-td>
                  <b-td> {{ formatNumber(fields.tax / 100) }}</b-td>
                  <b-td> {{ formatNumber(valueReceivable) }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
          <b-col cols="12" class="mt-2 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18">Dados do cliente</span>
          </b-col>
          <b-col cols="4">
            <Info
              label="Nome do cliente"
              :value="fields.client.name"
              :icon="'fas fa-file-signature'"
            />
          </b-col>
          <b-col cols="4">
            <Info
              label="E-mail"
              :value="fields.client.email"
              :icon="'fas fa-envelope-open-text'"
            />
          </b-col>
          <b-col cols="4">
            <p class="font-weight-bold">
              <i class="fas fa-mobile mr-2 c-orange fs-18"></i> Celular
            </p>
            <p v-html="maskCell(fields.client.cellphone)"></p>
          </b-col>
          <b-col cols="4" class="mt-4" v-if="fields.client.cnpj == ''">
            <Info
              label="RG"
              :value="fields.client.rg"
              :icon="'fas fa-id-card'"
            />
          </b-col>
          <b-col cols="4" class="mt-4" v-if="fields.client.cnpj == ''">
            <Info
              label="CPF"
              :value="fields.client.cpf"
              :icon="'fas fa-user'"
            />
          </b-col>
          <b-col cols="8" class="mt-4" v-if="fields.client.cnpj != ''">
            <Info
              label="CNPJ"
              :value="fields.client.cnpj"
              :icon="'fas fa-building'"
            />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info
              label="Criado em"
              :value="fields.client.createdAt"
              :icon="'fas fa-calendar'"
            />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info label="Quem mais Recebe/Retira" :value="fields.withdraw" />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info
              label="Recebido/Entregue para"
              :value="fields.received == '' ? received : fields.received"
            />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info label="Vendedor" :value="fields.clerk ? fields.clerk : ''" />
          </b-col>
        </b-row>
        <b-row v-if="dataShopkeeper" class="mt-2">
          <b-col cols="12" class="mt-4 mb-2 text-center cardTitleConst">
            <span class="font-weight-bold fs-18">Dados do Lojista</span>
          </b-col>
          <b-col cols="4">
            <Info label="Id" :value="dataShopkeeper.userId" />
          </b-col>
          <b-col cols="4">
            <Info
              label="Nome do lojista"
              :value="dataShopkeeper.nome_fantasia"
            />
          </b-col>
          <b-col cols="4">
            <Info label="CNPJ" :value="dataShopkeeper.cnpj" />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info label="Celular" :value="dataShopkeeper.celular" />
          </b-col>
          <b-col cols="4" class="mt-4">
            <Info label="E-mail" :value="dataShopkeeper.email" />
          </b-col>
          <b-col cols="8" class="mt-4">
            <Info label="Endereço" :value="addresShopkeeper()" />
          </b-col>
          <b-col cols="4" class="mt-4" v-if="dataShopkeeper.complemento">
            <Info label="Complemento" :value="dataShopkeeper.complemento" />
          </b-col>
        </b-row>
        <order-details-modal ref="orderDetailsModal"> </order-details-modal>
        <hr />
      </div>

      <footer>
        <b-row>
          <b-col cols="6">
            <span class="btn btn-primary btn-block" @click="impressOrder">
              Imprimir pedido
            </span>
          </b-col>
          <b-col cols="6">
            <span class="btn btn-danger btn-block" @click="closeModal">
              Fechar
            </span>
          </b-col>
        </b-row>
      </footer>
    </b-modal>

    <b-popover
      v-if="showConfirmationPopover"
      :show.sync="showConfirmationPopover"
      target="updateStatusButton"
      title="Confirmação"
      triggers="click"
      placement="bottom"
      variant="warning"
    >
      Tem certeza que deseja alterar o status do pedido para
      <strong>entregue</strong>? Após isso não será possível editar o status do
      pedido.

      <div class="row">
        <div class="col-md-12 mt-4">
          <label>Quem recebeu o pedido?</label>
          <input type="text" class="form-control" v-model="received.name" />
        </div>

        <div class="col-md-12 mt-2">
          <label>CPF:</label>
          <input
            type="text"
            class="form-control"
            v-model="received.cpf"
            v-mask="'###.###.###-##'"
          />
        </div>

        <div class="col-md-12 mt-2" v-if="tipoPedidoLoja == true">
          <label>Meio de pagamento utilizado:</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ex: Pix, Cartão, Boleto"
            v-model="received.payment"
          />
        </div>
      </div>

      <div class="mt-2">
        <b-button
          size="sm"
          variant="outline-danger"
          class="ml-auto mr-2"
          @click="
            () => {
              currentOrderBeingEditedId = 0;
              showConfirmationPopover = false;
            }
          "
        >
          <i class="fas fa-times mr-2"></i>
          Fechar
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="ChangeStatus(statusModal, (popover = true))"
        >
          <i class="fas fa-save mr-2"></i>
          Salvar
        </b-button>
      </div>
    </b-popover>
    <DetailServicePurchaseModal ref="detailServicePurchaseModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatNumber } from '@/utils';
import UserTypes from '@/enums/UserTypes';
import SelectProducts from '@/views/lojista/products/SelectProducts.vue';
import makeToast from '@/mixins/makeToast';
import OrderDetailsModal from '@/components/Order/OrderDetailsModal.vue';
import SelectItems from 'Components/Inputs/SelectItems.vue';
import Info from '../Inputs/Info.vue';
import ORDER_STATUS from 'Enums/Order/Status.js';
import DetailServicePurchaseModal from '@/views/lojista/services/DetailServicePurchaseModal.vue';

export default {
  name: 'OrderDetails',
  mixins: [makeToast],
  emits: ['get'],
  props: {
    shopkeepersIds: Array,
  },
  data() {
    return {
      loading: false,
      orderId: 0,
      uuid: 0,
      open: false,
      fields: this.defaultOrderDetails(),
      taxPayment: 0,
      valueReceivable: 0,
      dataShopkeeper: null,
      isEditing: false,
      ORDER_STATUS,
      popover: false,
      active: true,
      showConfirmationPopover: false,
      tipoPedidoLoja: false,
      currentOrderBeingEditedId: 0,
      statusModal: '',
      statusNow: '',
      allowPopover: false,
      dataModal: [],
      received: {
        name: '',
        cpf: '',
        payment: '',
      },
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
    orderStatusItems() {
      const items = [];
      Object.keys(ORDER_STATUS).forEach((key) => {
        if (
          ORDER_STATUS[key] != 1 &&
          ORDER_STATUS[key] != 6 &&
          ORDER_STATUS[key] != 5
        ) {
          if (ORDER_STATUS[key] != 7) {
            if (this.statusNow <= ORDER_STATUS[key]) {
              items.push({
                id: ORDER_STATUS[key],
                name: this.getOrderStatusText(ORDER_STATUS[key]),
              });
            }
          }
        }
      });
      return items;
    },

    orderStatusItemStore() {
      const items = [];
      Object.keys(ORDER_STATUS).forEach((key) => {
        if (
          ORDER_STATUS[key] != 1 &&
          ORDER_STATUS[key] != 6 &&
          ORDER_STATUS[key] != 5
        ) {
          if (ORDER_STATUS[key] != 3) {
            if (
              this.dataModal.status <= ORDER_STATUS[key] ||
              ORDER_STATUS[key] == 4
            ) {
              items.push({
                id: ORDER_STATUS[key],
                name: this.getOrderStatusText(ORDER_STATUS[key]),
              });
            }
          }
        }
      });
      return items;
    },
  },

  methods: {
    formatNumber,
    ...mapActions('shopkeeper', [
      'getOrderDetails',
      'getAppOrders',
      'updateOrderStatus',
    ]),
    toggleOpen({ orderId = 0, uuid = 0, data = null, dataModal = null }) {
      this.clean();

      this.open = !this.open;
      this.orderId = orderId;
      this.uuid = uuid;
      this.dataShopkeeper = data;
      this.dataModal = dataModal;
      this.get();
    },

    confirmUpdateStatusWhenFinishedorCancel(orderId, tipo = '') {
      this.tipoPedidoLoja = tipo == 'shopkeeper' ? true : false;
      this.currentOrderBeingEditedId = orderId;
      this.received.name = '';
      this.received.cpf = '';
      this.showConfirmationPopover = true;
    },

    tipoEntrega(tipo) {
      const entregas = {
        delivery: 'Entrega no endereço do cliente',
        motorcycle: 'Motoboy',
      };

      return entregas[tipo] || 'Retirada em loja';
    },

    ChangeStatus(modalStatus, popover = false) {
      if (modalStatus === this.dataModal.status || modalStatus === '') {
        this.makeToast(
          'Erro',
          'Não pode alterar para o mesmo status',
          'danger'
        );
        return;
      }

      if (popover == true && modalStatus == 4) {
        if (this.received.name == '' || this.received.cpf == '') {
          this.makeToast(
            'Erro',
            'Informe o NOME e CPF de quem recebeu/retirou o pedido!',
            'danger'
          );
          return;
        }
      } else {
        this.received.name = '';
        this.received.cpf = '';
        this.received.payment = '';
      }

      this.$store.dispatch('startLoader');
      this.updateOrderStatus({
        userId: this.userTypeId(),
        id: this.dataModal.id,
        newStatus: this.statusModal,
        received: this.received,
      })
        .then(() => {
          this.makeToast('Sucesso', 'Status do pedido atualizado com sucesso');
        })
        .catch((error) => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar o status do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.statusModal = '';
          this.isEditing = false;
          this.$bvModal.hide('modalProd');
          this.$emit('get');
        });
    },

    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },

    get() {
      if (this.loading || !this.orderId) return;

      this.loading = true;

      const data = {
        orderId: this.orderId,
        userId: this.userTypeId(),
        shopkeepersIds: this.userTypeId(true) || [],
      };
      this.getOrderDetails(data)
        .then((response) => {
          this.fields = response.data.data || {};
          this.taxView();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os dados do pedido',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    isEdit(value) {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        return this.editStatusClerk;
      }
      return !value.editing;
    },

    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.EXPIRED]: 'Expirado',
      };

      return texts[status] || 'N/A';
    },

    linkImage(value) {
      return process.env.VUE_APP_FOTOS_URL + value;
    },

    closeModal() {
      this.$bvModal.hide('modalProd');
      this.statusModal = '';
    },

    impressOrder() {
      const routeData = this.$router.resolve({
        name: 'print-order',
        query: {
          order: this.orderId,
          uuid: this.uuid,
        },
      });

      localStorage.setItem('dadosOrdemPrint', JSON.stringify(this.fields));
      localStorage.setItem(
        'dadosLojistaPrint',
        JSON.stringify(this.dataShopkeeper)
      );

      window.open(routeData.href, '_blank');
    },

    clean() {
      this.orderId = 0;
      this.fields = this.defaultOrderDetails();
      this.statusModal = '';
    },
    maskCell(value) {
      if (!value) return '';
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d)(\d{4})$/, '$1-$2');
      return value;
    },
    defaultOrderDetails() {
      return {
        totalValue: '',
        shipping: '',
        paymentType: '',
        client: '',
        received: '',
        withdraw: '',
        products: [],
      };
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira',
        shopkeeper: 'Recebimento com a loja',
      };
      return texts[type] || 'N/A';
    },
    taxView() {
      if (this.fields.paymentType == 'all') {
        this.taxPayment = 1.89;
      } else if (this.fields.paymentType == 'pix') {
        this.taxPayment = 0.5;
      } else if (this.fields.paymentType == 'credit_card') {
        this.taxPayment = this.fields.totalValue * 0.0235 + 0.3;
      } else {
        this.taxPayment = 0;
      }

      this.valueReceivable =
        this.fields.totalValue -
        this.taxPayment -
        Number(this.fields.tax / 100);
    },
    addresShopkeeper() {
      const address =
        this.dataShopkeeper.endereco +
        ', ' +
        this.dataShopkeeper.numero +
        ' - ' +
        this.dataShopkeeper.bairro +
        ' - ' +
        this.dataShopkeeper.cidade +
        '/' +
        this.dataShopkeeper.Estado;
      return address;
    },
    userTypeId(isShopkeepersId = false) {
      if (isShopkeepersId) {
        return this.$route.meta.userType == UserTypes.BALCONISTA
          ? this.dadosUsuario.construp_user_id
          : this.fields.shopkeepersIds;
      }
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
  components: {
    Info,
    SelectProducts,
    OrderDetailsModal,
    SelectItems,
    DetailServicePurchaseModal,
  },
};
</script>
<style scoped>
.informations {
  margin-right: 180px;
}

.cardTitleConst {
  background-color: #ff7f0042;
  border: 1px solid #ff7f00;
  border-radius: 3px;
  padding: 5px 0;
  color: #ff7f00;
  margin: 0 10px;
  max-width: 98%;
}

@media print {
  body * {
    visibility: hidden;
    background-color: white;
  }
  .menu,
  .banner {
    display: none;
  }

  #printable,
  #printable * {
    visibility: visible;
    background-color: white;
  }
  #printable {
    background-color: white;
    position: fixed;
    left: 20px;
    top: 10px;
    bottom: 0;
  }

  .onTop {
    position: absolute;
    z-index: 9999;
  }
}
</style>
